import type { ReactElement } from "react";

export function LimitsAndCosts(): ReactElement {
  return (
    <>
      <h2>Closing the tab is safe</h2>
      <p>
        Submitting a frame queues a job on the server. The work happens there, not in your browser,
        so a refresh, a closed tab or a lost connection does not lose it. Come back and the frame is
        either finished or still going.
      </p>
      <p>
        While anything is queued or running, the board checks for updates every second and a half
        and stops as soon as nothing is in flight.
      </p>

      <h2>Retries</h2>
      <p>
        A failure that is worth retrying — a rate limit, a timeout, a provider having a bad minute —
        is retried automatically, up to three attempts, with a growing gap between them.
      </p>
      <p>
        A failure that is not worth retrying is not retried. A content-policy refusal is the common
        one: the provider has decided, and sending the same prompt again gets the same answer.
        Reword it. Any failed frame can also be retried by hand from the inspector.
      </p>

      <h2>Limits</h2>
      <ul>
        <li>Prompts are capped at 8,000 characters.</li>
        <li>
          Uploads are capped by a size limit set by whoever runs this instance, and each model
          declares which file types it accepts and how many images it will take at once.
        </li>
        <li>Sign-in is limited to the addresses on the server's allowlist.</li>
      </ul>

      <h2>Cost</h2>
      <p>
        Nothing here meters spend. There is no budget, no quota and no running total. Every
        generation calls a paid API, and the only thing standing between a mistake and a bill is
        you.
      </p>
      <p>
        The pricing note on a model in the picker is guidance for whoever operates this instance,
        not a quotation. Providers change their prices; the note may be behind. Check the provider's
        own pricing page before assuming anything about cost.
      </p>

      <h2>What is stored</h2>
      <p>
        Darkroom keeps your prompts, your parameters, the images and the lineage between them, for
        as long as you keep them. Images generated here are AI-generated. If any of it is going to
        leave this application, transparency and content-marking obligations may apply — that is a
        question for compliance@savanta.com. No respondent or client data belongs in a prompt.
      </p>
    </>
  );
}
